import { render, staticRenderFns } from "./partner-space-form.vue?vue&type=template&id=270ef5d7"
import script from "./partner-space-form.vue?vue&type=script&lang=js"
export * from "./partner-space-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports